export const CREATE_FLOW = 'create-flow';
export const CREATE_TASK = 'create-task';
export const CREATE_POST = 'create-post';
